<template>
  <split-panel-page :scroll="false" :showRight="showHelp">
    <content-nav-bar class="content-nav-bar">
      <h5 v-if="admin" class="is-size-4 has-text-centered level-item">Edit Admin Analytic</h5>
      <h5 v-else class="is-size-4 has-text-centered level-item">Edit Analytic</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Saving Analytic</loader>
      <p v-if="message" class="message level-item">{{ message }}</p>
      <template slot="right">
        <a @click="showHelp = !showHelp" class="help-toggle">
          {{ helpMessage }} <i class="far fa-life-ring"></i>
        </a>
      </template>
    </content-nav-bar>
    <div class="full-height-scroll">
      <analytic-form
        :analytic="analytic"
        v-on:update:analytic="internalAnalytic = $event"
        v-on:update:analyticEventDef="eventDef = $event"
        :admin="admin">
        <!-- <div v-if="admin" class="form-section">
          <fieldset class="fieldset">
            <legend>Analytic Status</legend>
            <b-switch v-model="internalAnalytic.released">
              Released
            </b-switch>
          </fieldset>
        </div> -->
      </analytic-form>
    </div>
    <template slot="right">
      <content-nav-bar>
        <h5 class="is-size-4 has-text-centered level-item">Analytic Documentation</h5>
      </content-nav-bar>
      <analytic-help-panel
        v-if="eventDef"
        :def="eventDef"
        v-bind:class="{ 'hide-help': !showHelp }"
        class="help-section full-height-scroll">
      </analytic-help-panel>
    </template>
  </split-panel-page>
</template>

<script>
import analytic from '@/mixins/analytic';
import AnalyticForm from '@/components/analytics/forms/AnalyticForm.vue';
import AnalyticHelpPanel from '@/components/analytics/AnalyticHelpPanel.vue';
import SplitPanelPage from '@/components/SplitPanelPage.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'AnalyticEdit',
  mixins: [analytic],
  components: {
    AnalyticForm,
    AnalyticHelpPanel,
    SplitPanelPage,
    ContentNavBar,
    Loader,
  },
  props: {
    analytic: {
      type: Object,
      required: true,
    },
    admin: {
      type: Boolean,
      default: false,
    },
  },
  // beforeMount() {
  //   this.internalAnalytic = this.copyAnalytic(this.analytic, this.admin);
  // },
  data() {
    return {
      eventDef: null,
      showHelp: true,
      message: null,
      showLoader: false,
      internalAnalytic: this.analytic,
    };
  },
  computed: {
    helpMessage() {
      if (this.showHelp) {
        return 'Hide Help';
      }
      return 'Show Help';
    },
    endpoint() {
      if (this.admin) {
        return 'admin/updateAnalytic';
      }
      return 'primary/updateAnalytic';
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      // eslint-disable-next-line
      const analytic = await this.$store.dispatch(this.endpoint, this.internalAnalytic);
      this.showLoader = false;
      if (analytic) {
        this.message = 'Analytic saved';
        // this.$router.push({ name: 'analytics.index.detail', params: { id: analytic.uuid } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-height-scroll {
  flex-grow: 1;
  height: 100%;
  padding-bottom: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
